import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/my',
    name: 'my',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/MyView.vue')
  },
  {
    path: '/direct',
    name: 'direct',
    component: () => import('../views/direct.vue')
  },
  {
    path: '/community',
    name: 'community',
    component: () => import('../views/community.vue')
  },
  {
    path: '/ranking',
    name: 'ranking',
    component: () => import('../views/ranking.vue')
  },
  {
    path: '/prediction',
    name: 'prediction',
    component: () => import('../views/prediction.vue')
  },
  {
    path: '/walletOperations',
    name: 'walletOperations',
    component: () => import('../views/walletOperations.vue')
  },
  {
    path: '/eqxStake',
    name: 'eqxStake',
    component: () => import('../views/eqxStake.vue')
  },
  {
    path: '/tradeHistory',
    name: 'tradeHistory',
    component: () => import('../views/tradeHistory.vue')
  },
  {
    path: '/message',
    name: 'message',
    component: () => import('../views/message.vue')
  },
  {
    path: '/details',
    name: 'details',
    component: () => import('../views/details.vue')
  },
  {
    path: '/invite',
    name: 'invite',
    component: () => import('../views/invite.vue')
  },
  {
    path: '/amountDetails',
    name: 'amountDetails',
    component: () => import('../views/amountDetails.vue')
  },
  {
    path: '/revenueDetails',
    name: 'revenueDetails',
    component: () => import('../views/revenueDetails.vue')
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) return savedPosition
    return { x: 0, y: 0 }
  }
})

export default router
